import React from 'react';
import Color from '../../components/Color/Color';
import { useSelector } from 'react-redux';

const ColorContainer = () => {
    const { personalization } = useSelector(state => ({
        personalization: state.personalization
    }));
    return (
        <Color personalization={personalization} />
    );
};

export default ColorContainer
